var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 27 27",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M22.5 7.778a1.39 1.39 0 0 0-1.39-1.389H5.556a1.39 1.39 0 0 0-1.389 1.389v11.111a1.39 1.39 0 0 0 1.39 1.389H21.11a1.39 1.39 0 0 0 1.389-1.389zm1.666 11.111a3.056 3.056 0 0 1-3.055 3.056H5.555A3.055 3.055 0 0 1 2.5 18.889V7.778a3.055 3.055 0 0 1 3.055-3.056h15.556a3.055 3.055 0 0 1 3.055 3.056z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M22.87 7.085a.833.833 0 1 1 .925 1.386l-10 6.667a.83.83 0 0 1-.924 0l-10-6.667a.833.833 0 1 1 .924-1.386l9.538 6.358z"
  })));
};
export default SvgEmail;